import { ApiResource } from '../resource';
class TaxCalculators extends ApiResource {
    // static readonly PATH = 'tax_calculators'
    async list(params, options) {
        return this.resources.list({ type: TaxCalculators.TYPE }, params, options);
    }
    async retrieve(id, params, options) {
        return this.resources.retrieve({ type: TaxCalculators.TYPE, id }, params, options);
    }
    async markets(taxCalculatorId, params, options) {
        const _taxCalculatorId = taxCalculatorId.id || taxCalculatorId;
        return this.resources.fetch({ type: 'markets' }, `tax_calculators/${_taxCalculatorId}/markets`, params, options);
    }
    async attachments(taxCalculatorId, params, options) {
        const _taxCalculatorId = taxCalculatorId.id || taxCalculatorId;
        return this.resources.fetch({ type: 'attachments' }, `tax_calculators/${_taxCalculatorId}/attachments`, params, options);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    isTaxCalculator(resource) {
        return resource.type && (resource.type === TaxCalculators.TYPE);
    }
    relationship(id) {
        return ((id === null) || (typeof id === 'string')) ? { id, type: TaxCalculators.TYPE } : { id: id.id, type: TaxCalculators.TYPE };
    }
    type() {
        return TaxCalculators.TYPE;
    }
}
TaxCalculators.TYPE = 'tax_calculators';
export default TaxCalculators;
